export function isMD5Valid(md5: string) {
    var md5Regex = /^[a-fA-F0-9]{32}$/;

    return md5Regex.test(md5);
}
